import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'


const _hoisted_1 = { class: "inline-block relative bottom-0 left-0 text-12px xxl:text-14px mr-2 w-64" }
const _hoisted_2 = { class: "flex flex-row space-x-1" }
const _hoisted_3 = { class: "text-red-lp-100" }
const _hoisted_4 = {
  class: "absolute inset-y-0 right-0 flex items-center px-2",
  style: {"cursor":"pointer"}
}
const _hoisted_5 = {
  key: 0,
  class: "select w-full bg-white absolute border border-t-0 border-gray-lp-400 rounded-b-md px-2 z-50 overflow-x-show space-y-4 py-4",
  style: {"max-height":"80vh"}
}
const _hoisted_6 = { class: "text-red-lp-100 absolute top-0 right-0 mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.openFilter ? 'rounded-t' : 'rounded'
        } border text-black-lp-300 leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
      ,
      style: {"cursor":"pointer"},
      onClick: _cache[2] || (_cache[2] = 
        () => {
          _ctx.openFilter = !_ctx.openFilter;
          _ctx.$emit('opened', _ctx.openFilter);
        }
      )
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", null, _toDisplayString(_ctx.$t("podDex.filter.filter")), 1),
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.sumFilter ? `(${_ctx.sumFilter})` : ""), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.openFilter)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _imports_0,
              class: `w-4  ${_ctx.sumFilter ? 'arrow-red' : ''}`,
              alt: "up"
            }, null, 2))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              src: _imports_1,
              class: `w-4  ${_ctx.sumFilter ? 'arrow-red' : ''}`,
              onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isChevron = true;
            }
          ),
              alt: "down"
            }, null, 2))
      ])
    ], 2),
    (_ctx.openFilter)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          (_ctx.sumFilter)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
                class: "relative cursor-pointer w-full mb-4"
              }, [
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("podDex.filter.reset")), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('podDex.filter.sttType')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomDropdown, {
                isExpand: _ctx.customDropdownOpened.sttType,
                "onUpdate:isExpand": _cache[4] || (_cache[4] = ($event: any) => (_ctx.customDropdownOpened.sttType = $event)),
                options: _ctx.customDropdownOptions.sttType,
                onSelect: _cache[5] || (_cache[5] = e => _ctx.onSelectCustomDropdown(e, 'sttType')),
                placeholder: _ctx.$t('podDex.filter.selectSttType'),
                class: "w-full mt-2",
                isCustomWidth: "",
                selectedItem: _ctx.filterData.sttType
              }, null, 8, ["isExpand", "options", "placeholder", "selectedItem"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.filterData.sttType?.value === 'cod')
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                label: _ctx.$t('podDex.filter.codPaymentMethod')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.customDropdownOpened.paymentMethod,
                    "onUpdate:isExpand": _cache[6] || (_cache[6] = ($event: any) => (_ctx.customDropdownOpened.paymentMethod = $event)),
                    options: _ctx.customDropdownOptions.paymentMethod,
                    onSelect: _cache[7] || (_cache[7] = e => _ctx.onSelectCustomDropdown(e, 'paymentMethod')),
                    placeholder: _ctx.$t('podDex.filter.selectCodPaymentMethod'),
                    class: "w-full mt-2",
                    isCustomWidth: "",
                    selectedItem: _ctx.filterData.paymentMethod
                  }, null, 8, ["isExpand", "options", "placeholder", "selectedItem"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.openFilter = true;
          _ctx.$emit('opened', true);
          _ctx.isChevron = false;
        } else if (_ctx.openFilter) {
          _ctx.openFilter = false;
          _ctx.$emit('opened', false);
        }
      }
    ]
  ])
}